import { get, omit } from 'lodash';

import fromAnyToString from 'utils/converters/fromAnyToString';
import { transformPath } from 'utils/links/modify.util';
import asObject from 'utils/objects/asObject.util';

// DEPRECATED: don't use this one, it makes assumptions about the URL, instead linkTo() directly to the desired URL
const closeUrl = (location) => {
  const pathname = fromAnyToString(asObject(location).pathname);
  const position = pathname.includes('/week/') ? 6 : 5;

  return transformPath(
    // the following function removed the segments after the specified position
    (segments) => segments.filter((path, index) => index < position),
    pathname,
  );
};

const determineIfCustom = ({ categories, categoryId, field, stylistId, stylists, value }) => {
  if (!Number.isFinite(value)) {
    // not a valid number, so excluding a bug elsewhere,
    // consider it as if the user did a manual update (even if bad)
    return true;
  }

  const category = categoryId ? categories.find((c) => c.id === categoryId) : null;
  const services = category ? category.services || [] : null;
  const service = services ? services.find((s) => s.category === categoryId) : null;
  const executions = service ? service.role_executions || [] : null;

  const stylist = stylistId ? stylists.find((s) => s.id === stylistId) : null;
  const roleId = get(stylist, 'role.id');

  const execution = roleId && executions ? executions.find((x) => x.role_id === roleId) : null;
  const defaultValue = execution ? execution[field] : '';

  // convert both to string just in case one is and the other isn't
  return `${defaultValue}` !== `${value}`;
};

export const fromProcedureToAddedService = (procedure) => {
  const appointment = procedure && procedure.appointment;
  const service = procedure && procedure.service;
  return {
    ...omit(procedure, ['service', 'appointment']),
    service: service || undefined,
    appointment: appointment || undefined,
  };
};

export { closeUrl, determineIfCustom };

export default closeUrl;
